import axios from 'axios';
window.axios = axios;
System.prepareImport(true).then(function () {
	System.set(System.resolve('axios'), { default: window.axios, __useDefault: true });
});
